import { useEffect, lazy, Suspense } from "react";
import PrivateRoutes from "./pages/privateRoutes/privateRoutes";
import PublicRoute from "./pages/privateRoutes/publicRoute";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ShopProvider } from "./config/shopContext";
import MobileDownloadPopup from "./components/Mobile-download_poppup/index";
import { useDocumentMetadata } from "./hooks/useDocumentMetadata";
import Loader from "./components/Loader";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-image-gallery/styles/css/image-gallery.css";
import "./components/ShopItemsOwner/shopItems.css";
import "./style/Button.css";
import "./style/Fonts.css";
import "./style/Theme.css";
import "./style/style.css";
import "./style/Icons.css";
// Route-level code splitting: each page is downloaded only when visited.
import {Privacypolicy, GeneralTerms} from "./pages/index.js";
const Routing = lazy(() => import("./routes/index"));
const Withnavbar = lazy(
  () => import("./components/Navbar/Withnavbar/withnavbar"),
);
const ErrorPage = lazy(() => import("./pages/404Error/404Error"));
const EmailVerify = lazy(() => import("@/components/global/auth/email-verify"));
const Verifycode = lazy(() => import("@/components/common/verify-digits"));
const SelecteziAdvantages = lazy(() => import("./pages/Selectezi_Advantages"));
const SelecteziLandingPage = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Home"),
);
const Login = lazy(() => import("./pages/Auth/login/login"));
const Signup = lazy(() => import("./pages/Auth/signUp/signup"));
const Forgotpassword = lazy(
  () => import("./components/global/auth/forgot-password"),
);
const Verification = lazy(
  () => import("./components/global/auth/verification"),
);
const Resetpassword = lazy(
  () => import("./components/global/auth/reset-password"),
);
const Investment = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Investment/index.js"),
);
const Marketingguide = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Marketing/index.js"),
);
const Guideline = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Guideline/index.js"),
);
const PricingPage = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Pricing/index.js"),
);
const Marketingagent = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Marketing_Agent/index.jsx"),
);
const Showcase = lazy(
  () => import("./pages/SelectEzi_Landing_Page/Ranking_Guide/index.js"),
);
// Helper component to run the custom metadata update hook inside the router context
function MetadataManager() {
  useDocumentMetadata();
  return null;
}

const landingPageScrollPaths = new Set([
  "/",
  "/investment-opportunities",
  "/marketing-agent",
  "/hire-marketing-agent",
  "/guideline",
  "/pricing",
  "/selectezi-benefits",
  "/showcase",
  "/privacy-policy",
  "/general-terms",
  "/marketing-rewards",

]);

function LandingPageScrollbar() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.classList.toggle(
      "landing-page-scroll",
      landingPageScrollPaths.has(pathname),
    );
  }, [pathname]);

  useEffect(
    () => () => {
      document.documentElement.classList.remove("landing-page-scroll");
    },
    [],
  );

  return null;
}

function App() {
  return (
    <ShopProvider>
      <BrowserRouter>
        <MetadataManager />
        <LandingPageScrollbar />
        <MobileDownloadPopup />
        <Suspense fallback={<Loader heightsetting="vh-100" />}>
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot" element={<Forgotpassword />} />
              <Route path="/verification" element={<Verification />} />
              <Route path="/reset" element={<Resetpassword />} />
            </Route>

            {/* Email verification routes — always accessible */}
            <Route path="/404" element={<ErrorPage />} />
            <Route path="/email-verify" element={<EmailVerify />} />
            {/* <Route path="/verify-code/:email" element={<Verifycode />} /> */}
            <Route
              path="/selectezi-benefits"
              element={<SelecteziAdvantages />}
            />
            <Route path="/" element={<SelecteziLandingPage />} />
            <Route path="/investment-opportunities" element={<Investment />} />
            <Route path="/hire-marketing-agent" element={<Marketingguide />} />
            <Route path="/marketing-agent" element={<Marketingagent />} />

            <Route path="/guideline" element={<Guideline />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/showcase" element={<Showcase />} />
             <Route path="/privacy-policy" element={<Privacypolicy />} />
             <Route path="/general-terms" element={<GeneralTerms />} />

            

            {/* Protected routes — requires authentication */}
            <Route element={<PrivateRoutes />}>
              <Route element={<Withnavbar />}>
                <Route
                  path="*"
                  element={
                    <Suspense fallback={<Loader heightsetting="vh-100" />}>
                      <Routing />
                    </Suspense>
                  }
                />
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>

      <ToastContainer />
    </ShopProvider>
  );
}

export default App;
